<template>
  <div class="layout-index">
    <Head :active="'verify'"></Head>
    <div class="sector-article container">
      <div class="article">
        <h1>保函查验</h1>
        <div class="article-info"></div>
        <div class="padding-top-20"></div>
        <div class="article-content">
          <div class="Input-Button">
            <i-input placeholder="保函查询码" size="large" v-model="val"></i-input>
            <i-button type="primary" size="large" :loading="buttonLoading" @click="verifyGuaranteeAction">查验</i-button>
          </div>
          <div class="padding-top-20"></div>
          <div class="prompt-message">
            <p>保函查询码是一组11位的字符串，包括数字与字母</p>
            <p>您可在电子保函中找到它，填写在上面</p>
            <p>例：JO-SBM-3B6-UIL</p>
          </div>
          <div class="padding-top-20"></div>
          <div class="setcor-information">
            <div class="errBox" v-if="showErrBox">
              <div v-html="errBoxBody"></div>
              <a href="javascript:window.location.reload();">刷新重试</a>
            </div>
            <div class="sucBox" v-else>
              <div v-html="sucBoxBody"></div>
              <!-- <a href="javascript:window.location.reload();">刷新重试</a> -->
            </div>
          </div>
          <div class="padding-top-20"></div>
          <Table stripe :columns="tableColumns" :data="tableData" :loading="tableLoading" :show-header=false v-if="showTable" style="width: 100%;"></Table>
          <div class="padding-top-20"></div>
          <div class="padding-top-20"></div>
          <div class="explanation-of-results">
            <p><b>保函查询结果说明：</b></p>
            <p>1、<b>当且仅当</b>查询结果中<b>“保函状态”为“正常履约”</b>状态时，该保函为合法生效状态。</p>
            <p>2、查询结果中“保函状态”为“履约结束”状态时，说明该保函合法但已经过了保函约定的有效期。</p>
            <p>3、项目开标前，承保人、投标人等信息为隐藏状态，开标时间后，全部信息公开。</p>
          </div>
        </div>
        <div class="article-footer">
          <div class="small font-grey">来源：思创网联</div>
        </div>
      </div>
    </div>
    <Footer />
    <!-- <back-top></back-top> -->
  </div>
</template>

<script>
import Head from '../../components/header.vue'
import Footer from '../../components/footer.vue'
import Axios from 'axios'
// import promise from 'es6-promise'
// promise.polyfill()
// require('@babel/polyfill')
export default {
  components: {
    Head,
    Footer
  },
  data () {
    return {
      buttonLoading: false,
      tableLoading: true,
      showTable: false,
      showErrBox: true,
      guaInfo: {},
      errBoxBody: '<p><b>保函信息获取失败！</b> 保函不存在</p>',
      sucBoxBody: '',
      code: '',
      val: '',
      tableColumns: [
        {
          title: 'rowTitle',
          key: 'rowtitle'
        },
        {
          title: 'Value',
          key: 'value'
        }
      ],
      tableData: [
        {
          rowtitle: '保函编号',
          value: ''
        },
        {
          rowtitle: '项目名称',
          value: ''
        },
        {
          rowtitle: '受益人',
          value: ''
        },
        {
          rowtitle: '被保证人',
          value: ''
        },
        {
          rowtitle: '保证人',
          value: ''
        },
        {
          rowtitle: '担保额度',
          value: ''
        }
      ]
    }
  },
  mounted () {
  },
  methods: {
    getStatusName (p) {
      switch (p) {
        case 0:
          return '未知'
        case 1:
          return '未投保'
        case 2:
          return '未支付'
        case 3:
          return '待确认'
        case 4:
          return '拒绝承保'
        case 5:
          return '正常履约'
        case 6:
          return '履约结束'
        case 7:
          return '线下已付款待确认'
        case 99:
          return '已退保'
        default:
          return '未知'
      }
    },
    verifyGuaranteeAction () {
      if (process.env.NODE_ENV === 'development') {
        var host = 'localhost:8080'
      } else {
        host = 'fastoa.sclinker.com'
      }
      var baseUrl = 'http://' + host + '/api/v1/Guarantee/Verify'
      this.buttonLoading = true
      var data = {code: this.val}
      Axios.post(baseUrl, data).then((res) => {
        console.log(res)
        if (res.data.isSuccess === false) {
          this.showErrBox = true
          this.errBoxBody = '<p><b>保函信息获取失败！</b> ' + res.data.errorMessage + '</p>'
        } else {
          this.showErrBox = false
          this.sucBoxBody = '<p><b>查询成功</b><br>查询到编号<b>' + res.data.value.guaranteeNo + '</b>的保函</p>'
          this.guaInfo = res.data.value
          this.showTable = true
          this.tableData[0].value = this.guaInfo.guaranteeNo
          this.tableData[1].value = this.guaInfo.projectName
          this.tableData[2].value = this.guaInfo.beneficiary
          this.tableData[3].value = this.guaInfo.guaranteed
          this.tableData[4].value = this.guaInfo.guarantor
          this.tableData[5].value = this.guaInfo.amount + ' 元'
          this.tableLoading = false
        }
      })
        .catch((res) => {
          this.showErrBox = true
          this.errBoxBody = '<p><b>保函信息获取失败！</b> 网络错误</p>'
        })
      this.buttonLoading = false
    }
  }
}
</script>

<style lang="less" scoped>
.sector-title {
  margin: 20px auto;
}
.sector-article {
  margin: 150px auto;
}
.article {
  display: flex;
  flex-direction: column;
  align-items: center;
  .article-info {
    padding: 10px;
    width: 60%;
    text-align: center;
    border-bottom: 1px dashed #ccc;
  }
  .article-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 25px 10%;
  }
  .article-footer {
    float: right;
    margin-top: 40px;
    // display: flex;
    width: 80%;
    // flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .small.font-grey {
      float: right;
    }
  }
}
.Input-Button {
  display: flex;
  flex-direction: row;
  Input {
    margin-right: 20px;
  }
  Button {
    margin-left: 20px;
  }
}
.prompt-message {
  font-size: 12px;
  color: gray;
  text-align: center;
}
.setcor-information {
  width: 100%;
  .errBox {
    border: 1px solid;
    border-radius: 4px;
    padding: 10px 0;
    text-align: center;
    font-size: 14px;
    line-height: 2em;
    background-color: #ffe4e8;
    border-color: #cc5555;
  }
  .sucBox{
    border: 1px solid;
    border-radius: 4px;
    padding: 10px 0;
    text-align: center;
    font-size: 14px;
    line-height: 2em;
    background-color: #d2ffe1;
    border-color: #38ad65;
  }
  a {
      text-decoration: underline;
  }
}
.explanation-of-results {
  font-size: 12px;
  color: gray;
  text-align: left;
  line-height: 3em;
}
</style>



// WEBPACK FOOTER //
// src/pages/verify/verify.vue